import { isEmpty } from "lodash";
import ApiService from "../ApiService";

export default class FileDownloadUtils {
  static downloadFile = doc => {
    if (doc.url) {
      ApiService.getFile(
        doc.url,
        !isEmpty(doc.referral_document_name) ? doc.referral_document_name : doc.name,
      );
      return;
    }
  };
}
